/* Herlamora reviews — cross-fading quote carousel with prev/next arrows
   and an "n / total" counter. Slides are stacked in one grid cell
   (see section-herlamora-reviews.css), so switching is class-only. */

class HerlamoraReviews extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.counter = this.querySelector('[data-counter]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    this.index = Math.max(
      this.slides.findIndex((slide) => slide.classList.contains('is-active')),
      0
    );

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const slideIndex = this.slides.indexOf(event.target);
        if (slideIndex !== -1) this.show(slideIndex);
      });
    }
  }

  step(direction) {
    if (this.slides.length < 2) return;
    this.show((this.index + direction + this.slides.length) % this.slides.length);
  }

  show(index) {
    if (index === this.index && this.slides[index].classList.contains('is-active')) return;
    if (this.slides[this.index]) this.slides[this.index].classList.remove('is-active');
    this.index = index;
    this.slides[index].classList.add('is-active');
    if (this.counter) this.counter.textContent = `${index + 1} / ${this.slides.length}`;
  }
}

if (!customElements.get('herlamora-reviews')) {
  customElements.define('herlamora-reviews', HerlamoraReviews);
}
